import React from "react";
import { getConfiguration } from '../../utils/configuration';
import { getCurrencyValue } from '../../utils/getCurrencyValue';

function SystemBetsNTuple(props) {
    const conf = getConfiguration();
    const nDec = conf.cs.nd;
    const mult = conf.cs.m;
    const currency = conf.cs.ct;
    const isEvenIndex = (props.index+1)%2 == 0;
    //console.log(props.NTuple)

    return (
        <React.Fragment key={props.index} >
        {props.NTuple && props.NTuple.map((tuple,index)=>{
                return (
                    <tr key={`${props.index}_${index}`} id={`${props.index}_${index}`} className={(isEvenIndex?"evenRowsBlock":"oddRowsBlock")}>
                        {index == 0 && 
                            <td data-label="pr" className="singleBet" rowSpan={`${props.NTuple.length}`}>{props.index+1}</td>
                        }
                        
                        <td data-label="events">{tuple.eventDesc}</td>
                        <td data-label="bet">{tuple.betDesc}</td>
                        <td data-label="outcome">{tuple.outcome}</td>
                        <td data-label="odd">{tuple.odd}</td>
                        {index == 0 &&
                            <>
                                <td data-label="total-odd"   rowSpan={`${props.NTuple.length}`}>{tuple.totalOdd}</td>
                                <td data-label="amount"      rowSpan={`${props.NTuple.length}`}>{getCurrencyValue(tuple.amount, mult, nDec, currency)}</td>
                                {/*<td data-label="bonus"       rowSpan={`${props.NTuple.length}`}>{getCurrencyValue(tuple.bonus, mult, nDec, currency)}</td>*/}
                                <td data-label="winning" className={`${tuple.isWinning?'winning':tuple.isLosing?'losing':''} `} rowSpan={`${props.NTuple.length}`}>{getCurrencyValue(tuple.win, mult, nDec, currency)}</td>
                            </>
                        }
                    </tr>
                )
            })
        }     
        </React.Fragment>
    )
}

export default SystemBetsNTuple;